import { useLanguage } from "@tlc/ls2pac/components/Language";
import { EResourceCheckoutResponse } from "./DownloadableCheckoutDialog";
import { useAccount } from "@tlc/ls2pac/components/Account";
import { useIsMobile } from "../../../../hooks/useIsMobile";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import { Patron } from "@tlc/ls2pac/dto/Patron";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function getDownloadURL(
  response: EResourceCheckoutResponse,
  patron: Patron
) {
  const params = new URLSearchParams();
  params.set("itemId", response?.itemId);
  params.set("service", response?.service);
  params.set("patronId", patron?.patronId);
  return `eResource/redirect?${params.toString()}`;
}

interface OverdriveIFrameDialogProps {
  open: boolean;
  onClose: () => void;
  src: string;
}
export const OverdriveIFrameDialog = ({
  open,
  onClose,
  src,
}: OverdriveIFrameDialogProps) => {
  const { translate } = useLanguage();
  const { patron, isAuthenticated } = useAccount();
  const isMobile = useIsMobile();

  if (!isAuthenticated || !open || !src) {
    return null;
  }

  return (
    <>
      {isMobile ? (
        <Dialog
          fullScreen
          open={open}
          onClose={onClose}
          slots={{
            transition: Transition,
          }}
        >
          <AppBar
            sx={{
              position: "relative",
              backgroundColor: "transparent",
              boxShadow: "none",
            }}
          >
            <Toolbar sx={{ backgroundColor: "transparent" }}>
              <IconButton
                edge="start"
                color="default"
                onClick={onClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "#000" }}
                variant="h6"
                component="div"
              >
                {translate("checkoutEResourceDialogTitle")}
              </Typography>
            </Toolbar>
          </AppBar>
          <DialogContent sx={{ overflowY: "hidden" }}>
            <iframe
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              src={src}
            ></iframe>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          fullScreen={false}
          open={open}
          onClose={onClose}
          maxWidth={false}
          scroll="body"
        >
          <DialogTitle>{translate("checkoutEResourceDialogTitle")}</DialogTitle>
          <DialogContent
            sx={{
              minWidth: 472,
              flex: 1,
              p: 0,
            }}
          >
            <iframe
              style={{
                width: "100%",
                height: "100%",
                minHeight: "632px",
                border: "none",
              }}
              src={src}
            ></iframe>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose}>{translate("close")}</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
